import {H2} from "./styles";

export default function PageTitle({children} : {children : any}){
  return(
    <H2>
      {children}
    </H2>
  );
}
